<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-row>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="fullName" v-model="localData.fullName" label="نام طرف حساب*" :error-messages="errorMessages" :rules="[() => !!localData.fullName || 'نام را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="businessName" v-model="localData.businessName" label="نام تجاری*" :error-messages="errorMessages" :rules="[() => !!localData.businessName || 'نام تجاری را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="شماره تماس" />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field v-model="localData.bankInfo" maxlength="500" label="شماره حساب" />
				</v-col>
				<v-col cols="12" md="12" class="py-0">
					<v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید']" />
				</v-col>
			</v-row>
			<div class="mt-3">
				<small>*فیلدهای ستاره دار ضروری هستند.</small>
			</div>
		</v-form>

		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck',false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark @click="submit" :loading="loading">
				ذخیره
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyAgent',
		components: {
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				datePickerValidatioin: '',
				loading: false,
			}
		},
		mounted() {
			this.prepareData()
		},
		computed: {
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.loading = true
				api.post('admin/contact/' + (this.localData.id === 0 ? 'create' : 'edit'), this.localData)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('admin/contact/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === 0) Object.assign(this.localData, this.data)
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
		},
	}
</script>
<style>
</style>
